let activeTaskCount = 0

function announce() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('mobile-runtime-state', { detail: { activeTaskCount } }))
  }
}

export function beginMobileForegroundTask() {
  activeTaskCount += 1
  announce()
  let finished = false
  return () => {
    if (finished) return
    finished = true
    activeTaskCount = Math.max(0, activeTaskCount - 1)
    announce()
  }
}

export function hasActiveMobileForegroundTask() {
  return activeTaskCount > 0
}

export function getActiveMobileForegroundTaskCount() {
  return activeTaskCount
}
